import React from "react"
import { useTranslation } from "react-i18next"
import { MultilangJob } from "src/services/api/document"
import FileCard from "./FileCard"
import Browser from "src/components/browser/Browser"

interface Props {
  browserTitle: string
  jobs?: MultilangJob[]
  showDownloadButton?: boolean
  showDeadline?: boolean
  totalCount: number
  refresh: () => void
  setMultilangJob: (multilangJob?: MultilangJob) => void
  setActivePage: (activePage: number) => void
  onOpenEmailModal: () => void
}

const FileBrowser = ({
  browserTitle,
  jobs,
  showDownloadButton,
  showDeadline,
  totalCount,
  refresh,
  setMultilangJob,
  setActivePage,
  onOpenEmailModal
}: Props) => {
  const { t } = useTranslation("common")

  return (
    <Browser
      browserTitle={browserTitle}
      noDataMessage={t("files.noFiles")}
      onPageChange={(activePage) => setActivePage(activePage)}
      totalCount={totalCount}
    >
      {jobs &&
        jobs.map((job) => {
          return (
            <FileCard
              key={job.id}
              job={job}
              showDownloadButton={showDownloadButton}
              showDeadline={showDeadline}
              onInfoClick={setMultilangJob}
              onModalClose={refresh}
              onOpenEmailModal={onOpenEmailModal}
            />
          )
        })}
    </Browser>
  )
}

export default FileBrowser
